import React from 'react';
import axios from 'axios';
import FontAwesome from 'react-fontawesome';
import {Button, ControlLabel, Form, FormControl, FormGroup, HelpBlock, OverlayTrigger, Popover} from "react-bootstrap";
import Files from 'react-files';
import {withRouter} from "react-router-dom";

import Loading from "../../components/Loading/index";
import './style.css';

class QuestionImageForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            inProcess: false,
            loading: this.props.match.params.id ? true : false,
            values: {
                file: [],
                picture: null
            },
            validation: {
                messages: {
                    file: ''
                },
                states: {
                    file: null
                }
            }
        };

        this.handleChangeImage = this.handleChangeImage.bind(this);
        this.handleDeleteImage = this.handleDeleteImage.bind(this);

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    componentDidMount() {
        if (this.props.sessionData && this.props.sessionData.accessToken) {
            this.getQuestion();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.sessionData && nextProps.sessionData.accessToken && nextProps.active && !this.state.loaded) {
            this.getQuestion();
        }
    }

    getQuestion() {
        if (this.props.match.params.id) {
            let loginToken = this.props.sessionData.accessToken;
            let config = {
                headers: {
                    'Authorization': 'Bearer ' + loginToken
                }
            };
            axios.get(this.props.api.questions + "/" + this.props.match.params.id, config)
            .then((response) => {
                if (!this._componentWillUnmount) {
                    this.setState({
                        values: {
                            file: [],
                            id: response.data.id,
                            picture: response.data.pictureLink ? `${__APIURL__}/${response.data.pictureLink}` : null
                        },
                        loading: false
                    });
                }
            }).catch((error) => {
                this.props.addNotification('error', error.response.status, 'Nepodařilo se načíst otázku!');
                this.props.history.push('/questions');
                console.log("Axios error: ", error);
            });
        }
    }

    // file input handles
    handleChangeImage(image) {
        let values = this.state.values;
        let validation = this.state.validation;

        if (image.length !== 0) {
            let file = image[0];
            let img = new Image();
            // let sizeLimit = this.props.size;
            let component = this;
            img.onload = function() {
                // let height = img.height;
                // let width = img.width;
                //
                // // dimension check
                // if (width !== sizeLimit.width || height !== sizeLimit.height) {
                //     values.file = [];
                //     validation.states.file = 'error';
                //     validation.messages.file = 'Rozměry fotky neodpovídají daným omezením!';
                //     component.setState({
                //         values,
                //         validation
                //     });
                // } else {
                //     values.file = image;
                //     let reader = new FileReader();
                //     reader.onload = function () {
                //         values.pictureBase64 = reader.result;
                //     };
                //     reader.readAsDataURL(file);
                //     validation.states.file = 'success';
                //     validation.messages.file = '';
                //     component.setState({
                //         values,
                //         validation
                //     });
                // }
                values.file = image;
                let reader = new FileReader();
                reader.onload = function () {
                    values.pictureBase64 = reader.result;
                };
                reader.readAsDataURL(file);
                validation.states.file = 'success';
                validation.messages.file = '';
                component.setState({
                    values,
                    validation
                });
            };
            let _URL = window.URL || window.webkitURL;
            img.src = _URL.createObjectURL(file);
        } else {
            validation.messages.file = '';
            validation.states.file = null;
        }

        this.setState({
            values,
            validation
        })
    }

    handleDeleteImage() {
        let loginToken = this.props.sessionData.accessToken;
        let config = {
            headers: {
                'Authorization': 'Bearer ' + loginToken
            }
        };
        axios.post(this.props.api.questionPictureDelete + "/" + this.props.match.params.id, {}, config)
            .then(() => {
                let values = this.state.values;
                values.file = [];
                values.pictureBase64 = undefined;
                values.picture = null;
                this.setState({
                    values
                });
                this.refs.file.removeFiles()
            })
            .catch((error) => {
                console.log("Axios error: ", error);
            });
    }

    isValid () {
        return (Object.values(this.state.validation.states).indexOf('error') < 0);
    }

    handleSubmit(event) {
        event.preventDefault();
        if (this.isValid()) {
            this.setState({inProcess: true});
            this.props.action(this.state.values);
        }
    }

    handleClose() {
        this.props.history.push('/questions');
    }

    render() {
        let title = this.props.title;
        let {messages, states} = this.state.validation;
        let values = this.state.values;

        const popoverInfo = (
            <Popover id="popover-info" title="Omezení nahráveného obrázku">
                <p>Obrázek musí splňovat tyto omezení:</p>
                <ul>
                    <li><strong>Velikost</strong> musí být {this.props.size.width}x{this.props.size.height}</li>
                    <li><strong>Formát obrázku</strong> musí být PNG.</li>
                </ul>
            </Popover>
        );


        return (
            <div className="x-panel">
                <div className="x-title">
                    <h2>{title}</h2>
                    <div className="clearfix"/>
                </div>
                <div className="x-content">
                    {
                        this.state.loading ? <Loading/> :
                            <Form onSubmit={this.handleSubmit}>
                                <div className="col-lg-offset-3 col-md-offset-3 col-sm-offset-3 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <FormGroup controlId="file" validationState={states.file}>
                                        <ControlLabel>Obrázek</ControlLabel>
                                        <Files
                                            ref='file'
                                            className='files-dropzone-gallery-single'
                                            onChange={this.handleChangeImage}
                                            onError={this.handleChangeImageError}
                                            accepts={['image/png']}
                                            multiple={false}
                                            clickable
                                        >
                                            <FormControl.Feedback />
                                            {
                                                values.file.length > 0
                                                    ? <div className='files-gallery-single'>
                                                        {values.file.map((file) =>
                                                            <img className='files-gallery-single-item' src={file.preview.url} alt='' key={file.id} />
                                                        )}
                                                    </div>
                                                    : this.state.values.picture ?
                                                    <img className='files-gallery-single-item' src={this.state.values.picture} alt='' key={values.id} />
                                                    : <div>Zde vložte obrázek</div>
                                            }
                                        </Files>
                                        <Button type='button' className="btn btn-danger" onClick={this.handleDeleteImage}>Smazat</Button>
                                        <OverlayTrigger trigger={['hover', 'focus']} placement="right" overlay={popoverInfo}>
                                            <FontAwesome name="info-circle" tag="i" size="2x"/>
                                        </OverlayTrigger>
                                        <HelpBlock>{messages.file}</HelpBlock>
                                    </FormGroup>
                                    <div className="clearfix"/>
                                    <div className="ln-solid"/>
                                    <FormGroup>
                                        <div className="col-md-offset-4">
                                            <Button className="btn-primary" type="button" onClick={this.handleClose}>Zpět</Button>
                                            <Button type="submit" className="btn btn-success">{this.props.button}</Button>
                                            {this.state.inProcess && <Loading/>}
                                        </div>
                                    </FormGroup>
                                </div>
                            </Form>
                    }
                </div>
            </div>
        );
    }
}

export default withRouter(QuestionImageForm);



/** WEBPACK FOOTER **
 ** ./src/containers/Questions/QuestionImageForm.js
 **/